import { ProjectStatsParams } from 'modules/projects/types';

import { ProjectStatsContext } from './const';

export interface IProjectStatsProviderProps {
  children: React.ReactNode;
  value: ProjectStatsParams;
}

export const ProjectStatsProvider = ({
  children,
  value,
}: IProjectStatsProviderProps) => {
  return (
    <ProjectStatsContext.Provider value={value}>
      {children}
    </ProjectStatsContext.Provider>
  );
};
